import { Reveal, SectionHead } from "./Reveal";
import { useLang } from "../i18n";

const ABOUT_IMG = "/assets/about-export.jpg";

export const About = () => {
  const { t } = useLang();
  return (
    <section id="apropos" data-testid="about-section" className="bg-oris-cream py-24 lg:py-36">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <SectionHead overline={t.about.overline} title={t.about.title} testId="about-title" />

        <div className="grid gap-16 lg:grid-cols-12">
          <div className="lg:col-span-7">
            <Reveal>
              <div className="max-w-2xl space-y-4 text-base leading-relaxed text-oris-moss lg:text-lg">
                {t.about.intro.split("\n\n").map((para, i) => (
                  <p key={i}>{para}</p>
                ))}
              </div>
            </Reveal>

            <div className="mt-14 divide-y divide-oris-green/12 border-y border-oris-green/12">
              {t.about.chapters.map((c, i) => (
                <Reveal key={c.n} delay={i * 0.06}>
                  <div
                    data-testid={`manifesto-chapter-${c.n}`}
                    className="group grid grid-cols-12 gap-4 py-9 transition-colors duration-500 hover:bg-white"
                  >
                    <div className="col-span-3 sm:col-span-2">
                      <span className="font-serif text-4xl font-medium text-oris-gold/80 transition-colors duration-500 group-hover:text-oris-gold lg:text-5xl">
                        {c.n}
                      </span>
                    </div>
                    <h3 className="col-span-9 font-serif text-2xl font-medium text-oris-ink sm:col-span-4 lg:text-3xl">
                      {c.title}
                    </h3>
                    <p className="col-span-12 text-sm leading-relaxed text-oris-moss sm:col-span-6 lg:text-base">
                      {c.text}
                    </p>
                  </div>
                </Reveal>
              ))}
            </div>
          </div>

          <div className="lg:col-span-5">
            <Reveal delay={0.15} className="lg:sticky lg:top-28">
              <figure className="group">
                <div className="spotlight-frame overflow-hidden">
                  <img
                    src={ABOUT_IMG}
                    alt="Terres agricoles à l'origine des filières ORIS"
                    loading="lazy"
                    className="aspect-[4/5] w-full object-cover transition-transform duration-700 ease-out group-hover:scale-105"
                  />
                </div>
                <figcaption className="mt-4 flex items-center gap-3 text-[0.7rem] font-semibold uppercase tracking-[0.22em] text-oris-moss">
                  <span className="gold-rule" aria-hidden="true" />
                  {t.about.imageCaption}
                </figcaption>
              </figure>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
};
